import React from 'react'

const CHUNK_RELOAD_KEY = 'chunk-reload-at'
const CHUNK_RELOAD_WINDOW_MS = 10000

const isChunkLoadError = (error) =>
  error?.name === 'ChunkLoadError' || /Loading (CSS )?chunk \S+ failed/.test(error?.message)

const reloadedRecently = () =>
  Date.now() - Number(sessionStorage.getItem(CHUNK_RELOAD_KEY)) < CHUNK_RELOAD_WINDOW_MS

class ErrorBoundary extends React.Component {
  state = { hasError: false, error: null, isReloading: false }
  static getDerivedStateFromError(error) {
    return {
      hasError: true,
      error,
      isReloading: isChunkLoadError(error) && !reloadedRecently(),
    }
  }
  componentDidCatch() {
    if (this.state.isReloading) {
      sessionStorage.setItem(CHUNK_RELOAD_KEY, Date.now())
      window.location.reload()
    }
  }
  render() {
    if (this.state.hasError) {
      return this.state.isReloading ? this.props.loading : this.props.fallback
    }
    return this.props.children
  }
}

export default ErrorBoundary
